import React from "react";
import MedicalPlanDetails from "../pages/medical/medical-plan-details.jsx";
import VisionPlanDetails from "../pages/vision/vision-plan-details";
import FsaPlanDetails from "../pages/fsa/fsa-plan-details.jsx";
import DentalPlanDetails from "../pages/dental/dental-plan-details.jsx";
import DisabilityPlanDetails from "../pages/disability/disability-plan-details.jsx";
import { PlanType } from "./enums/plan-type.js";

const PlanHeader = ({ planOption, planType, planTitle, planDetailsInfo, planId }) => {
  switch (planType) {
    case PlanType.Medical:
      planTitle = "Medical";
      planDetailsInfo = <MedicalPlanDetails planId={planId} />;
      break;
    case PlanType.Vision:
      planTitle = "Vision";
      planDetailsInfo = <VisionPlanDetails />;
      break;
    case PlanType.Dental:
      planTitle = "Dental";
      planDetailsInfo = <DentalPlanDetails />;
      break;
    case PlanType.ShortTermDisability:
      planTitle = "Disability";
      planDetailsInfo = <DisabilityPlanDetails />;
      break;
    case PlanType.FlexibleSpendingAccount:
      planTitle = "FSA";
      planDetailsInfo = <FsaPlanDetails />;
      break;
    default:
      planTitle = "Unknown";
  }

  return (
    <>
      <div className="flex flex-col sm:flex-row items-center mb-4 mt-2 ">
        <div className="order-1 text-3xl sm:mr-16">{planTitle}</div>
        <div
          className="order-3 sm:order-2 sm:mr-16"
          label="Paycheck Deduction:"
        >
          Paycheck Deduction: ${planOption?.cost || 0}
        </div>
        <div className="order-2">{planDetailsInfo}</div>
      </div>
      {planType === PlanType.Dental ? (
        <div className=" text-base font-normal">
          Dental plan is covered for employees and dependents at no cost to
          employees.
        </div>
      ) : (
        <></>
      )}
      <br></br>{" "}
    </>
  );
};

export default PlanHeader;
